module.exports = "/images/DiagramWhite.jpg";